import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { State } from '~/store/types';
import ResidentHeader from '~/components/ResidentHeader';
import { t } from '~/i18n';
import { observer } from 'mobx-react';

const ResidentHeaderObserver = observer(ResidentHeader);

interface ResidentHeaderContainerProps {
  residentDetail: State['residentDetail'];
  name?: string;
  showEditProfile?: boolean;
}

const ResidentHeaderContainer: React.FC<ResidentHeaderContainerProps> = ({ residentDetail, name, showEditProfile }) => {
  const { profile } = residentDetail;
  const navigate = useNavigate();

  const handleResidentRemove = React.useCallback(() => {
    if (!profile) return;
    profile.archive().then(() => {
      navigate('/residents');
    });
  }, [profile, navigate]);
  if (!profile) {
    return null;
  }
  return (
    <ResidentHeaderObserver
      name={name || profile.fullName}
      residentId={profile.id}
      profileImage={profile.profileImage}
      gender={profile.gender}
      onDelete={handleResidentRemove}
      showEditProfile={showEditProfile}
      siteName={profile.site?.name}
      profile={profile}
      numbers={[
        {
          icon: 'battery',
          number: profile.ownedDevice?.batteryLevel ? `${profile.ownedDevice.batteryLevel}%` : '',
          label: t('residentDetail.header.batteryLevel'),
        },
        {
          icon: 'katz',
          number: profile.healthLevel ?? profile.katzLevel ?? '',
          label: t('profile.healthLevel'),
        },
      ]}
    />
  );
};

export default ResidentHeaderContainer;
